

// ---- 全局事件, 用户没有登录. 
export const GLOBAL_USER_NOT_LOGIN = 'GLOBAL_USER_NOT_LOGIN'; 

export const TOP_TOOLBAR_DO_QUERY = 'TOP_TOOLBAR_DO_QUERY'; 
export const TOP_TOOLBAR_DO_ADD = 'TOP_TOOLBAR_DO_ADD';  


// 合同审核状态重设
export const CONTRACT_AUDIT_STATUS_RESET_OK = 'CONTRACT_AUDIT_STATUS_RESET_OK';  


// WEBPACK FOOTER //
// ./src/helper/Events.js